
import React from "react";
import { Trash2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import LogicToggle from "@/components/tags/LogicToggle";
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
  TooltipProvider
} from "@/components/ui/tooltip";

interface TagFilterControlsProps {
  logicType: "AND" | "OR";
  onLogicTypeChange: (newLogicType: "AND" | "OR") => void;
  onClearSelections: (e: React.MouseEvent) => void;
}

const TagFilterControls: React.FC<TagFilterControlsProps> = ({
  logicType,
  onLogicTypeChange,
  onClearSelections
}) => {
  return (
    <div className="flex items-center justify-between px-3 py-1 bg-accent border-y border-border h-8">
      <div className="flex items-center">
        <LogicToggle 
          value={logicType}
          onChange={onLogicTypeChange}
          defaultValue="AND"
          className="ml-0.5 h-5 w-5 mr-3"
        />
        <span className="text-sm font-medium text-foreground">Filter Mode</span>
      </div>
      
      <TooltipProvider>
        <Tooltip>
          <TooltipTrigger asChild>
            <Button 
              variant="ghost" 
              size="sm" 
              className="h-6 w-6 p-0 text-muted-foreground hover:text-red-500"
              onClick={onClearSelections}
            >
              <Trash2 size={16} />
            </Button>
          </TooltipTrigger>
          <TooltipContent>Clear all filters</TooltipContent>
        </Tooltip>
      </TooltipProvider>
    </div>
  );
};

export default TagFilterControls;
